import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Params } from '@angular/router';
import { RoutablePagingNavItem } from '@hrra/core';

@Component({
    selector: 'hrra-routable-paging',
    templateUrl: './routable-paging.component.html',
    styleUrls: ['./routable-paging.component.scss'],
    standalone: false
})
export class RoutablePagingComponent implements OnInit {

  @Input() currentPage: number;
  
  @Input() pagingNavItems: RoutablePagingNavItem[];
  @Input() previousePageQueryParams: any;
  @Input() nextPageQueryParams: any;

  @Input() pageCount: number;

  @Input() queryParams: any;

  constructor() { }

  ngOnInit(): void {
  }

}

